module.exports = __webpack_public_path__ + "media/stylesheets/images/logo5-827c9a02d5fb2c0dd930949b75cf1ae3.gif";